import * as React from 'react'

import { cn } from '@/lib/utils'

function Textarea({ className, ...props }) {
    return (
        <textarea
            data-slot="textarea"
            className={cn(
                // Base styles from UI component
                'tw:border-input tw:placeholder:text-muted-foreground tw:focus-visible:border-ring tw:focus-visible:ring-ring/50',
                'tw:aria-invalid:ring-destructive/20 tw:dark:aria-invalid:ring-destructive/40 tw:aria-invalid:border-destructive',
                'tw:dark:bg-background tw:flex tw:field-sizing-content tw:min-h-16 tw:w-full tw:rounded-xs tw:border tw:bg-transparent',
                'tw:px-3 tw:py-2 tw:!text-sm tw:shadow-xs tw:transition-[color,box-shadow] tw:focus-visible:border-blue-500 tw:focus-visible:border-[1px]',
                'tw:disabled:cursor-not-allowed tw:disabled:opacity-50 tw:text-sm',
                // Additional styles from setAdContent textarea
                'tw:file:text-foreground tw:selection:bg-muted-foreground/70 tw:selection:text-primary-foreground tw:border-[#3B5168] tw:min-w-0',
                'tw:outline-none tw:resize-none tw:pr-32 tw:overflow-y-auto tw:scrollbar-hide tw:disabled:pointer-events-none',
                'tw:md:text-sm tw:h-[58px]',
                className,
            )}
            style={{ resize: 'none', scrollbarWidth: 'none', msOverflowStyle: 'none', ...props.style }}
            {...props}
        />
    )
}

export { Textarea }
